/*
 * @FilePath: operateConfig.js
 * @Author: Aron
 * @Date: 2023-07-21 11:27:05
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-08-22 19:00:18
 * Copyright: 2023 xxxTech CO.,LTD. All Rights Reserved.
 * @Descripttion:
 */
export default [
  {
    path: "AgentFirstPaymentReward",
    name: "AgentFirstPaymentReward",
    meta: {
      title: "首笔合同款奖励查询"
    },
    component: () =>
      import("@/views/Home/OperationCenter/ChannelAgents/AgentFirstPaymentReward")
  },
  {
    path: "CrossRegionalReview",
    name: "CrossRegionalReview",
    meta: {
      title: "跨区域活跃设备申诉审核"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/CrossRegionalReview/index.vue"
      )
  },
  {
    path: "RewardSharing",
    name: "RewardSharing",
    meta: {
      title: "昂立渠道奖励分担"
    },
    component: () =>
      import("@/views/Home/OperationCenter/ChannelAgents/RewardSharing")
  },
  {
    path: "RegionCustomers",
    name: "RegionCustomers",
    meta: {
      title: "区域内转介绍客户"
    },
    component: () =>
      import("@/views/Home/OperationCenter/ChannelAgents/RegionCustomers")
  },
  {
    path: "RebatesAndFees",
    name: "RebatesAndFees",
    meta: {
      title: "返佣和服务费查询"
    },
    component: () =>
      import("@/views/Home/OperationCenter/ChannelAgents/RebatesAndFees")
  },
  {
    path: "purchasing",
    name: "purchasing",
    meta: {
      title: "采购订单"
    },
    component: () =>
      import("@/views/Home/OperationCenter/PurchasingManagment/Purchasing")
  },
  {
    path: "SecondmentGoods",
    name: "SecondmentGoods",
    meta: {
      title: "借调货管理"
    },
    component: () =>
      import("@/views/Home/OperationCenter/PurchasingManagment/SecondmentGoods")
  },
  {
    path: "Creditorders",
    name: "Creditorders",
    meta: {
      title: "赊货管理"
    },
    component: () =>
      import("@/views/Home/OperationCenter/PurchasingManagment/Creditorders")
  },
  {
    path: "DoubleOrder",
    name: "DoubleOrder",
    meta: {
      title: "双重订单"
    },
    component: () =>
      import("@/views/Home/OperationCenter/PurchasingManagment/DoubleOrder")
  },
  {
    path: "DoubleOrderCreation",
    name: "DoubleOrderCreation",
    meta: {
      title: "创建双重订单"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/PurchasingManagment/page/DoubleOrderCreation"
      )
  },
  {
    path: "HeadOfficeShipment",
    name: "HeadOfficeShipment",
    component: () =>
      import(
        "@/views/Home/OperationCenter/DistrictAgentManagement/HeadOfficeShipment/HeadOfficeShipment"
      ),
    meta: {
      title: "总部发货"
    }
  },
  {
    path: "AreaConsignment",
    name: "AreaConsignment",
    meta: {
      title: "区域发货记录"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/DistrictAgentManagement/AreaConsignment/index"
      )
  },
  {
    path: "AreaJdSend",
    name: "AreaJdSend",
    meta: {
      title: "区代京东仓发货"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/DistrictAgentManagement/AreaJdSend/index"
      )
  },
  {
    path: "SaleConsignmentDetail",
    name: "SaleConsignmentDetail",
    meta: {
      title: "区代京东仓发货详情"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/DistrictAgentManagement/AreaJdSend/saleConsignmentDetail"
      )
  },
  {
    path: "JdSendParamConfig",
    name: "JdSendParamConfig",
    meta: {
      title: "京东仓发货参数配置"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/DistrictAgentManagement/JdSendParamConfig/index"
      )
  },
  {
    path: "Experience",
    name: "Experience",
    meta: {
      title: "体验管理"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/SubscriptionCardManagement/Experience/index"
      )
  },
  {
    path: "SubPartnerProfile",
    name: "SubPartnerProfile",
    meta: {
      title: "下级合作伙伴档案"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/SubPartnerProfile/index"
      )
  },
  {
    path: "SubPartnerProfileDetail",
    name: "SubPartnerProfileDetail",
    meta: {
      title: "下级合作伙伴档案详情"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/SubPartnerProfile/detail.vue"
      )
  },
  {
    path: "ContactConfig",
    name: "ContactConfig",
    meta: {
      title: "运营联系人配置"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/ContactConfig/index"
      )
  },
  {
    path: "SubscriptionManagement",
    name: "SubscriptionManagement",
    meta: {
      title: "订阅卡管理"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/SubscriptionCardManagement/SubscriptionCard/index"
      )
  },
  {
    path: "dealerRestrictionManagement",
    name: "dealerRestrictionManagement",
    meta: {
      title: "经销商限制管理"
    },
    component: () => import('@/views/Home/DataCenter/BusinessData/dealerRestrictionManagement/index')
  },
  {
    path: "SquirrelJuvenile",
    name: "SquirrelJuvenile",
    meta: {
      title: "松鼠少年报名管理"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/SquirrelJuvenile/index"
      )
  },
  {
    path: "SalesData",
    name: "SalesData",
    meta: {
      title: "本省销售资料管理"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/SalesData/index"
      )
  },
  {
    path: "CatalogManagement",
    name: "CatalogManagement",
    meta: {
      title: "资料分类目录"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/CatalogManagement/index"
      )
  },
  {
    path: "AccountControl",
    name: "AccountControl",
    meta: {
      title: "学员账号管控管理"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/Compliance/AccountControl"
      )
  },
  {
    path: "LearningMap",
    name: "LearningMap",
    meta: {
      title: "员工学习账号管控管理"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/Compliance/LearningMap"
      )
  },
  {
    path: "HardDevices",
    name: "HardDevices",
    meta: {
      title: "硬件设备管控管理"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/Compliance/HardDevices"
      )
  },
  {
    path: "ReportConfirm",
    name: "ReportConfirm",
    meta: {
      title: "跨区域激活报备复核"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/ReportConfirm"
      )
  },
  {
    path: "CheckSquirrelJuvenile",
    name: "CheckSquirrelJuvenile",
    meta: {
      title: "松鼠少年报名审核"
    },
    component: () =>
      import(
        "@/views/Home/OperationCenter/SquirrelJuvenile/checkSquirrelJuvenile"
      )
  },
  {
    path: "PurchaseCreation",
    name: "PurchaseCreation",
    component: () =>
      import(
        "@/views/Home/OperationCenter/PurchasingManagment/page/PurchaseCreation"
      ),
    meta: {
      title: "创建采购订单"
    }
  },
  {
    path: "SecondmentDetails",
    name: "SecondmentDetails",
    component: () =>
      import(
        "@/views/Home/OperationCenter/PurchasingManagment/page/SecondmentDetails"
      ),
    meta: {
      title: "借调货管理"
    }
  },
  {
    path: "studyMachine",
    name: "studyMachine",
    component: () =>
      import("@/views/Home/OperationCenter/EquipmentManagement/studyMachine"),
    meta: {
      title: "学习机管理"
    }
  },
  {
    path: "barterManage",
    name: "barterManage",
    component: () =>
      import("@/views/Home/OperationCenter/EquipmentManagement/barterManage"),
    meta: {
      title: "换货管理"
    }
  },
  {
    path: "barterManage/information",
    name: "barterManage/information",
    component: () =>
      import("@/views/Home/OperationCenter/EquipmentManagement/barterManage/information"),
    meta: {
      title: "换货管理"
    }
  },
  {
    path: "PrototypeManagement",
    name: "PrototypeManagement",
    component: () =>
      import(
        "@/views/Home/OperationCenter/EquipmentManagement/PrototypeManagement"
      ),
    meta: {
      title: "样机管理"
    }
  },
  {
    path: "ChildrenDevice",
    name: "ChildrenDevice",
    component: () =>
      import("@/views/Home/OperationCenter/EquipmentManagement/ChildrenDevice"),
    meta: {
      title: "教师子女机管理"
    }
  },
  {
    path: "ChildrenDeviceDetails",
    name: "ChildrenDeviceDetails",
    component: () =>
      import(
        "@/views/Home/OperationCenter/EquipmentManagement/page/ChildrenDeviceDetails"
      ),
    meta: {
      title: "子女机详情"
    }
  },
  {
    path: "AdvertiseMessage",
    name: "AdvertiseMessage",
    component: () => import("@/views/Home/showCard/AdvertiseMessage"),
    meta: {
      title: "公告中心"
    }
  },
  {
    path: "AdvertiseMessageDetail",
    name: "AdvertiseMessageDetail",
    component: () => import("@/views/Home/showCard/AdvertiseMessageDetail"),
    meta: {
      title: "公告中心"
    }
  },
  {
    path: "CreditordersCreation",
    name: "CreditordersCreation",
    component: () =>
      import(
        "@/views/Home/OperationCenter/PurchasingManagment/page/CreditordersCreation"
      ),
    meta: {
      title: "验货订单"
    }
  },
   {
    path: "saleConsignmentDetail",
    name: "saleConsignmentDetail",
    component: () =>
      import(
        "@/views/Home/OperationCenter/DistrictAgentManagement/AreaJdSend/saleConsignmentDetail"
      ),
    meta: {
      title: "详情"
    }
  },
  {
   path: "TakeDelivery",
   name: "TakeDelivery",
   component: () =>
     import(
       "@/views/Home/OperationCenter/CloudWarehouseManagement/TakeDelivery"
     ),
   meta: {
     title: "仓内提货"
   }
 },
 {
    path: "LoanAndReturn",
    name: "LoanAndReturn",
    component: () =>
      import(
        "@/views/Home/OperationCenter/CloudWarehouseManagement/LoanAndReturn"
      ),
    meta: {
      title: "仓间借还货"
    }
  },
  {
    path: "DeliveryCreation",
    name: "DeliveryCreation",
    component: () =>
      import(
        "@/views/Home/OperationCenter/CloudWarehouseManagement/page/DeliveryCreation"
      ),
    meta: {
      title: "新建提货单"
    }
  },
  {
    path: "AllocationCreation",
    name: "AllocationCreation",
    component: () =>
      import(
        "@/views/Home/OperationCenter/CloudWarehouseManagement/page/AllocationCreation"
      ),
    meta: {
      title: "新建调拨单"
    }
  },
  {
    path: "DeliveryDetail",
    name: "DeliveryDetail",
    component: () =>
      import(
        "@/views/Home/OperationCenter/CloudWarehouseManagement/page/DeliveryDetail"
      ),
    meta: {
      title: "提货单详情"
    }
  },
  {
    path: "AllocationDetail",
    name: "AllocationDetail",
    component: () =>
      import(
        "@/views/Home/OperationCenter/CloudWarehouseManagement/page/AllocationDetail"
      ),
    meta: {
      title: "调拨单详情"
    }
  },
  {
    path: "CloudProduct",
    name: "CloudProduct",
    component: () =>
      import(
        "@/views/Home/OperationCenter/CloudWarehouseManagement/CloudProduct"
      ),
    meta: {
      title: "云仓商品库存统计"
    }
  },
  {
    path: "CloudWarehouse",
    name: "CloudWarehouse",
    component: () =>
      import(
        "@/views/Home/OperationCenter/CloudWarehouseManagement/CloudWarehouse"
      ),
    meta: {
      title: "云仓仓库库存统计"
    }
  },
  {
    path: "StoreMap",
    name: "StoreMap",
    component: () =>
      import(
        "@/views/Home/OperationCenter/StoreMap/index.vue"
      ),
    meta: {
      title: "经销商门店地图"
    }
  },
  {
    path: "CloudStorageDetail",
    name: "CloudStorageDetail",
    component: () => import('@/views/Home/OperationCenter/CloudWarehouseManagement/CloudStorageDetail'),
    meta: {
      title: "云仓入库明细"
    }
  },
  {
    path: "CloudStorageFlow",
    name: "CloudStorageFlow",
    component: () => import('@/views/Home/OperationCenter/CloudWarehouseManagement/CloudStorageFlow'),
    meta: {
      title: "云仓库存流水"
    }
  },
  {
    path: "CloudDeliveryOrder",
    name: "CloudDeliveryOrder",
    component: () => import('@/views/Home/OperationCenter/CloudWarehouseManagement/CloudDeliveryOrder'),
    meta: {
      title: "云仓发货顺序"
    }
  },
  // 运营中心-战略/事业合伙人路由配置
  {
    path: "partner/equity",
    name: "partnerEquity",
    component: () => import('@/views/Home/OperationCenter/Partner/Equity'),
    meta: {
      title: "合伙人权益管理"
    }
  },
  {
    path: "partner/first-reward",
    name: "partnerFirstReward",
    component: () => import('@/views/Home/OperationCenter/Partner/FirstReward'),
    meta: {
      title: "合伙人首笔款奖励"
    }
  },
  {
    path: "partner/renewal-reward",
    name: "partnerRenewalReward",
    component: () => import('@/views/Home/OperationCenter/Partner/RenewalReward'),
    meta: {
      title: "合伙人续费奖励"
    }
  },
  {
    path: "partner/introduce-customer",
    name: "partnerIntroduceCustomer",
    component: () => import('@/views/Home/OperationCenter/Partner/IntroduceCustomer'),
    meta: {
      title: "合伙人转介绍客户"
    }
  },
  {
    path: "partner/renewalRewardShare",
    name: "RenewalRewardShare",
    component: () => import('@/views/Home/OperationCenter/Partner/AgentRenewalRewardShare'),
    meta: {
      title: "代理商续费奖励分担"
    }
  }
  
];
